module.exports = __webpack_public_path__ + "img/SHProductType.5dea7bcf.svg";